<div class="row">
  <div class="col-12 col-md-6">
    <div class="row mb-4">
      <div class="col-12 mb-4 d-flex flex-row justify-content-between">
        <h1 class="mt-0 mb-0">{{ 'PAYMENT_INFORMATION' | translate }}</h1>
      </div>

      <!--<div class="col-12">
        <lib-gung-input-multi-select label="PAYER_COMPANY" [optionsList]="payerCompanyOptions"
          [(ngModel)]="checkout.extra.oh.kundbetalarenr" [showId]="false" [previewField]="['id', ' - ', 'name']"
          singleSelection="true"></lib-gung-input-multi-select>
      </div>-->

      <!--<div class="col-12 mb-3">
        <lib-gung-select-option-input [optionsList]="payerCompanyOptions" [(ngModel)]="checkout.extra.oh.kundbetalarenr"
          gungTranslate="PAYER_COMPANY" extraHostClass="mb-0"></lib-gung-select-option-input>
      </div>-->

      <div class="col-12 mb-3">
        <b>{{ 'PAYER_COMPANY' | translate }}</b>
        <app-hl-display-customer-selection-typeahead (customerSelected)="customerSelected($event)"
          [startSelectedCustomerId]="startPayerCompanyId" />
      </div>

      <div class="col-12">
        <lib-gung-select-option-input gungTranslate="PAYMENT_TERMS" [optionsList]="paymentTermsOptions"
          [(ngModel)]="checkout.extra.oh.betkod"></lib-gung-select-option-input>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 mb-3">
        <div class="form-check form-check-inline form-check-big mr-5">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1"
            [checked]="checkout.extra.oh.faktslutlevorder"
            (change)="checkout.extra.oh.faktslutlevorder = !checkout.extra.oh.faktslutlevorder" />
          <label class="form-check-label" for="inlineCheckbox1">{{
            'INVOICE_FULLY_DELIVERED_ORDER' | translate
            }}</label>
        </div>

        <div class="form-check form-check-inline form-check-big mr-5">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox2"
            [checked]="checkout.extra.oh.q_hl_edi_cancel"
            (change)="checkout.extra.oh.q_hl_edi_cancel = !checkout.extra.oh.q_hl_edi_cancel" />
          <label class="form-check-label" for="inlineCheckbox2">{{ 'CANCEL_EDI_MESSAGE' | translate }}</label>
        </div>

        <div class="form-check form-check-inline form-check-big mr-5">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox4"
            [ngModel]="checkout.extra.oh.samfaktutskr" [checked]="checkout.extra.oh.samfaktutskr"
            (change)="checkout.extra.oh.samfaktutskr = !checkout.extra.oh.samfaktutskr" />
          <label class="form-check-label" for="inlineCheckbox4">{{ 'COLLECTIVE_INVOICING' | translate }}</label>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 mb-3">
        <div class="form-check form-check-inline form-check-big mr-5">
          <input type="checkbox" id="inlineCheckbox5" class="form-check-input"
            [ngModel]="checkout.extra._ignoreAllBrokenBoxFees" (ngModelChange)="ignoreAllBrokenBoxFeeChanged()" />
          <label class="form-check-label" for="inlineCheckbox5">
            {{ 'IGNORE_ALL_BROKEN_BOX_FEES' | translate }}
          </label>
        </div>
        <br>
        <div class="form-check form-check-inline form-check-big mr-5">
          <input type="checkbox" id="inlineCheckbox3" class="form-check-input" [checked]="!checkout.extra._skipAdminFee"
            (change)="emitSkipAdminFee()" />
          <label class="form-check-label" for="inlineCheckbox3">
            {{ 'CHARGE_SMALL_ORDER_FEE' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <div class="row mb-4">
      <div class="col-12 mb-4 d-flex flex-row justify-content-between">
        <h1 class="mt-0 mb-0">{{ 'INVOICE_NOTIFICATIONS' | translate }}</h1>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-text-input [(ngModel)]="checkout.extra.oh.q_hl_emailaddr_to"
          gungTranslate="EMAIL_ADDRESS_TO"
          [extraInputClass]="highlightEmailFields ? 'highlight-input' : ''"></lib-gung-text-input>
      </div>

      <div class="col-12">
        <lib-gung-text-input [(ngModel)]="checkout.extra.oh.q_hl_emailaddr_cc"
          gungTranslate="EMAIL_ADDRESS_CC"
          [extraInputClass]="highlightEmailFields ? 'highlight-input' : ''"></lib-gung-text-input>
      </div>

      <div class="col-12" *ngIf="showEmailWarning">
        <small class="text-danger email-warning-text">
          <i class="fas fa-exclamation-triangle"></i>
          {{ 'PAYER_COMPANY_CHANGED_EMAIL_WARNING' | translate }}
        </small>
      </div>
    </div>
    <div class="row mb-4">
      <div class="form-check-big">
        <input class="form-check-input" type="checkbox" id="inlineCheckbox6"
          [checked]="checkout.extra.oh.q_hl_emailnotification"
          (change)="checkout.extra.oh.q_hl_emailnotification = !checkout.extra.oh.q_hl_emailnotification" />
        <label class="form-check-label" for="inlineCheckbox6">{{ 'SEND_INVOICE_BY_EMAIL' | translate }}</label>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6"></div>
</div>
